import './style.css'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as loginActions from '../../redux/actions/login.action'

import report from '../../assets/images/report-ico.svg'
import changebranch from '../../assets/images/change-branch.svg'
import more_icon from '../../assets/images/more-ico.svg'
import dashboardIcon from '../../assets/images/dash-board-icon.svg'
import { RootReducers } from '../../redux/reducers'
import { isBranchAdmin, isBranchStaff } from '../../helpers/roles'

export const StaffMenu = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const loginState = useSelector((state: RootReducers) => state.loginReducer)

  const checkBranchStaff = () => {
    if (loginState.isError) return false
    if (loginState.account) {
      return isBranchStaff(loginState.account?.agentInfo.role as string)
    }
  }

  const checkBranchAdmin = () => {
    if (loginState.isError) return false
    if (loginState.account) {
      return isBranchAdmin(loginState.account?.agentInfo.role as string)
    }
  }

  return (
    <div className={`header-bar-menu-header ${checkBranchStaff() ? '' : ' hide'}`}>
      <div className="menu-bar">
        <div className="menu-item">
          <Link to="/">
            <div>
              {' '}
              <img className="img-status" src={dashboardIcon} alt="icon" />
            </div>
            <div>ข้อมูลใบรับเงินชั่วคราว</div>
          </Link>
        </div>

        <div className="menu-item">
          <Link to="/StaffReport">
            <div>
              {' '}
              <img className="img-status" src={report} alt="icon" />
            </div>
            <div>e-TR Report</div>
          </Link>
        </div>

        {/* <div className="menu-item">
          <Link to="/PaymentDetail">
            <div>
              {' '}
              <img className="img-status" src={report} alt="icon" />
            </div>
            <div>Payment Detail</div>
          </Link>
        </div> */}

        <div className="menu-item">
          <Link
            to="/ChangeBranch"
            className={`header-bar-menu-header ${checkBranchAdmin() ? '' : ' hide'}`}
          >
            <div>
              {' '}
              <img className="img-status" src={changebranch} alt="icon" />
            </div>
            <div>เปลี่ยนแปลงสาขา</div>
          </Link>
        </div>
        {/* <div className="menu-item">
          <Link to="#">
            <div>
              {' '}
              <img className="img-status" src={more_icon} alt="icon" />
            </div>
            <div>อื่น ๆ</div>
          </Link>
        </div> */}
      </div>
    </div>
  )
}
